import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiIntegration } from '../../_services/api.integration';
import { fromEvent } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
@Component({
  selector: 'app-activation',
  templateUrl: './activation.component.html',
  styleUrls: ['./activation.component.css']
})
export class ActivationComponent implements OnInit {
  titleMessage: string;
  token: any;
  constructor(private http: HttpClient, private route: ActivatedRoute, private api: ApiIntegration) {
  }
  ngOnInit() {
    this.activateKey();
  }

  activateKey() {
    let key = this.route.snapshot.params['key'];
    this.api.activateKey(key).pipe(debounceTime(3000)).subscribe((data: any) => {
      if (data['code'] == 200) {
        this.token = data.token;
      }
      console.log(data);
    });
  }
}
